module.exports = __webpack_public_path__ + "static/media/dashboardIcon.4b90363e.svg";